import { render, staticRenderFns } from "./b_OtherServices.vue?vue&type=template&id=6b0e9e20&"
import script from "./b_OtherServices.vue?vue&type=script&lang=js&"
export * from "./b_OtherServices.vue?vue&type=script&lang=js&"
import style0 from "./b_OtherServices.vue?vue&type=style&index=0&id=6b0e9e20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports